import { useState } from "react";
import SeoHead from "@/components/feature/SeoHead";
import AuthModal from "./components/AuthModal";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://www.crownhongyunmall.com";
const PAGE_PATH = "/crowntalk";

const crownchatJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Crowntalk",
    "alternateName": "皇冠通话",
    "applicationCategory": "CommunicationApplication",
    "applicationSubCategory": "SocialNetworkingApplication",
    "operatingSystem": "iOS 14.0+, Android 8.0+",
    "description": "Crowntalk 全球社交通讯应用，支持1080P高清视频通话、即时消息、AI实时翻译50+语言，覆盖180+国家，连接全球任何人。国内华为、小米、OPPO、vivo等安卓手机可直接安装APK，无需Google服务。",
    "url": `${SITE_URL}/crowntalk`,
    "downloadUrl": `${SITE_URL}/crowntalk#download`,
    "screenshot": "https://public.readdy.ai/ai/img_res/915e9d3f36929c2102be9cfaf1d51676.jpg",
    "softwareVersion": "3.2.1",
    "fileSize": "98MB",
    "releaseNotes": "Crowntalk 支持全球180+国家视频通话，AI实时翻译，端对端加密",
    "inLanguage": ["zh-CN", "en", "ja", "ko", "ar"],
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "CNY",
      "availability": "https://schema.org/InStock"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "200000000",
      "bestRating": "5",
      "worstRating": "1"
    },
    "author": {
      "@type": "Organization",
      "name": "皇冠鸿运商城 Crown HongYun Mall",
      "url": SITE_URL
    },
    "featureList": [
      "全球高清视频通话 1080P",
      "即时文字语音消息",
      "AI实时翻译50+语言",
      "端对端加密保护",
      "超大群组最多5000人",
      "商城直连购物",
      "节日礼物分享",
      "国内安卓APK直接安装"
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Crowntalk 全球社交通讯应用下载 | 皇冠鸿运商城",
    "description": "Crowntalk — 像微信一样简单，连接全球任何人。1080P高清视频通话，50+语言AI实时翻译，覆盖180+国家，支持苹果App Store及国内安卓手机直接安装APK。",
    "url": `${SITE_URL}/crowntalk`,
    "inLanguage": "zh-CN",
    "isPartOf": {
      "@type": "WebSite",
      "name": "皇冠鸿运商城 Crown HongYun Mall",
      "url": SITE_URL
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "首页", "item": SITE_URL },
        { "@type": "ListItem", "position": 2, "name": "Crowntalk", "item": `${SITE_URL}/crowntalk` }
      ]
    },
    "mainEntity": {
      "@type": "SoftwareApplication",
      "name": "Crowntalk",
      "url": `${SITE_URL}/crowntalk`
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Crowntalk 是什么应用？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Crowntalk 是皇冠鸿运商城官方全球社交通讯应用，支持1080P高清视频通话、即时消息、AI实时翻译，覆盖全球180+国家，像微信一样简单，连接全球任何人。"
        }
      },
      {
        "@type": "Question",
        "name": "国内手机（华为、小米、OPPO）可以用 Crowntalk 吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "可以！Crowntalk 提供 APK 安装包，无需 Google 服务，华为、小米、OPPO、vivo、荣耀、一加等所有国内安卓手机均可直接下载安装，与 App Store 版本功能完全一致。"
        }
      },
      {
        "@type": "Question",
        "name": "Crowntalk 支持哪些语言翻译？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Crowntalk 内置 AI 实时翻译功能，支持中文、英语、日语、韩语、阿拉伯语等 50+ 种语言，跨语言交流零障碍，和外国朋友聊天不再困难。"
        }
      },
      {
        "@type": "Question",
        "name": "Crowntalk 视频通话画质如何？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Crowntalk 支持 1080P 超清视频通话，低延迟技术确保通话流畅，支持最多 50 人同时视频会议，并采用弱网优化技术，网络不稳定时自动优化保持通话流畅。"
        }
      },
      {
        "@type": "Question",
        "name": "Crowntalk 是免费的吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "是的，Crowntalk 完全免费下载和使用，无广告，无隐藏收费。支持 iOS App Store 和 Android APK 直接下载，注册即可立即使用全部功能。"
        }
      },
      {
        "@type": "Question",
        "name": "Crowntalk 如何保护用户隐私？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Crowntalk 采用军事级别端对端加密技术，所有消息和通话内容完全私密，任何第三方（包括 Crowntalk 服务器）均无法窃听或读取用户的通话和消息内容。"
        }
      }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "皇冠鸿运商城 Crown HongYun Mall",
    "url": SITE_URL,
    "logo": "https://public.readdy.ai/ai/img_res/f704ac6a-a45e-41ab-b34d-a4b4313691a9.png",
    "sameAs": [
      SITE_URL
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["Chinese", "English"]
    }
  }
];

const features = [
  {
    icon: "ri-video-chat-line",
    title: "全球高清视频通话",
    desc: "与全球任何人一对一或多人视频通话，1080P 超清画质，低延迟，就像面对面交流一样真实。",
    color: "bg-red-500",
    tag: "核心功能",
  },
  {
    icon: "ri-message-3-line",
    title: "即时文字 & 语音消息",
    desc: "支持文字、语音、图片、视频、文件全类型消息，全球实时传递，毫秒级响应，永不掉线。",
    color: "bg-orange-500",
    tag: "",
  },
  {
    icon: "ri-global-line",
    title: "连接全球任何人",
    desc: "覆盖全球 180+ 国家和地区，无论对方在哪个国家，只要有网络，随时随地都能联系。",
    color: "bg-green-500",
    tag: "",
  },
  {
    icon: "ri-group-3-line",
    title: "超大群组 & 社区",
    desc: "创建最多 5000 人的超大群组，打造属于你的购物社区、家族群、兴趣圈子。",
    color: "bg-amber-500",
    tag: "",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "端对端加密保护",
    desc: "军事级别端对端加密技术，所有消息和通话内容完全私密，任何第三方无法窃听。",
    color: "bg-teal-500",
    tag: "",
  },
  {
    icon: "ri-translate-2",
    title: "AI 实时翻译",
    desc: "内置 AI 实时翻译，支持 50+ 语言，跨语言交流零障碍，和外国朋友聊天不再困难。",
    color: "bg-pink-500",
    tag: "",
  },
  {
    icon: "ri-gift-line",
    title: "节日礼物分享",
    desc: "一键分享皇冠鸿运商城商品，节日礼品推荐，让购物变成社交体验，礼物直达好友。",
    color: "bg-red-400",
    tag: "",
  },
  {
    icon: "ri-store-line",
    title: "商城直连购物",
    desc: "直接在 Crowntalk 内浏览皇冠鸿运商城商品，一键购买，分享给好友，购物社交一体化。",
    color: "bg-indigo-500",
    tag: "",
  },
];

const downloadOptions = [
  {
    id: "appstore",
    icon: "ri-apple-line",
    title: "App Store",
    subtitle: "iPhone & iPad",
    desc: "要求 iOS 14.0 或更高版本",
    size: "128MB",
    btnText: "在 App Store 下载",
    btnClass: "bg-gray-900 hover:bg-gray-800 text-white",
    iconClass: "text-white",
    badge: "官方正版",
    badgeClass: "bg-gray-700 text-gray-300",
  },
  {
    id: "googleplay",
    icon: "ri-android-line",
    title: "Google Play",
    subtitle: "Android 手机",
    desc: "要求 Android 8.0 或更高版本",
    size: "98MB",
    btnText: "在 Google Play 下载",
    btnClass: "bg-green-600 hover:bg-green-700 text-white",
    iconClass: "text-green-400",
    badge: "全球版",
    badgeClass: "bg-green-900 text-green-300",
  },
  {
    id: "apk",
    icon: "ri-download-cloud-line",
    title: "APK 安装包",
    subtitle: "华为 / 小米 / OPPO / vivo",
    desc: "适用于所有国内安卓手机，无需 Google 服务",
    size: "98MB",
    btnText: "直接下载 APK",
    btnClass: "bg-red-500 hover:bg-red-600 text-white",
    iconClass: "text-red-400",
    badge: "国内推荐",
    badgeClass: "bg-red-900 text-red-300",
  },
];

const phoneScreens = [
  {
    img: "https://readdy.ai/api/search-image?query=smartphone%20screen%20showing%20modern%20chat%20messaging%20app%20interface%20with%20contact%20list%20and%20message%20bubbles%2C%20clean%20dark%20UI%20design%2C%20professional%20mobile%20app%20mockup%2C%20no%20text%20overlay%2C%20minimal%20background&width=320&height=580&seq=cc_screen1&orientation=portrait",
    label: "即时消息",
  },
  {
    img: "https://readdy.ai/api/search-image?query=smartphone%20screen%20showing%20video%20call%20interface%20with%20two%20people%20faces%20on%20screen%2C%20modern%20app%20UI%2C%20clean%20design%2C%20professional%20mobile%20mockup%2C%20no%20text%20overlay%2C%20minimal%20background&width=320&height=580&seq=cc_screen2&orientation=portrait",
    label: "视频通话",
  },
  {
    img: "https://readdy.ai/api/search-image?query=smartphone%20screen%20showing%20group%20chat%20interface%20with%20multiple%20participants%20and%20emoji%20reactions%2C%20modern%20app%20UI%2C%20clean%20design%2C%20professional%20mobile%20mockup%2C%20no%20text%20overlay%2C%20minimal%20background&width=320&height=580&seq=cc_screen3&orientation=portrait",
    label: "群组聊天",
  },
];

const reviews = [
  {
    name: "Sarah M.",
    country: "🇺🇸 美国",
    avatar: "S",
    avatarBg: "bg-blue-500",
    rating: 5,
    content: "Crowntalk is amazing! I can video call my family in China with crystal clear quality. It's just like WeChat but works everywhere globally!",
  },
  {
    name: "田中 健",
    country: "🇯🇵 日本",
    avatar: "T",
    avatarBg: "bg-red-500",
    rating: 5,
    content: "Crowntalで中国の友達と毎日話しています。翻訳機能が素晴らしくて、言語の壁を感じません！",
  },
  {
    name: "李小明",
    country: "🇨🇳 中国",
    avatar: "L",
    avatarBg: "bg-orange-500",
    rating: 5,
    content: "用了很多聊天软件，Crowntalk 是最好用的！视频通话超清晰，国内手机直接下载 APK 就能用，太方便了！",
  },
  {
    name: "Emma K.",
    country: "🇬🇧 英国",
    avatar: "E",
    avatarBg: "bg-purple-500",
    rating: 5,
    content: "The video call quality is outstanding! I use it daily to connect with friends across different countries. Highly recommend!",
  },
  {
    name: "Ahmed R.",
    country: "🇦🇪 阿联酋",
    avatar: "A",
    avatarBg: "bg-green-500",
    rating: 5,
    content: "Best messaging app I've ever used. The real-time translation feature is a game changer for international business communication.",
  },
  {
    name: "王芳",
    country: "🇨🇳 中国",
    avatar: "W",
    avatarBg: "bg-pink-500",
    rating: 5,
    content: "华为手机直接下载 APK 就能用，和海外朋友视频通话画质超清晰，完全不卡，强烈推荐！",
  },
];

const stats = [
  { value: "2亿+", label: "全球用户", icon: "ri-user-line" },
  { value: "180+", label: "覆盖国家", icon: "ri-earth-line" },
  { value: "50+", label: "支持语言", icon: "ri-translate-2" },
  { value: "1080P", label: "视频画质", icon: "ri-hd-line" },
];

const compatiblePhones = [
  { brand: "华为", models: "Mate / P / Nova 系列", icon: "ri-smartphone-line" },
  { brand: "小米", models: "Redmi / Mi / POCO 系列", icon: "ri-smartphone-line" },
  { brand: "OPPO", models: "Find / Reno / A 系列", icon: "ri-smartphone-line" },
  { brand: "vivo", models: "X / S / Y 系列", icon: "ri-smartphone-line" },
  { brand: "荣耀", models: "Magic / X / Play 系列", icon: "ri-smartphone-line" },
  { brand: "一加", models: "OnePlus 全系列", icon: "ri-smartphone-line" },
  { brand: "三星", models: "Galaxy S / A / M 系列", icon: "ri-smartphone-line" },
  { brand: "iPhone", models: "iPhone 8 及以上", icon: "ri-smartphone-line" },
];

const demoScenarios = [
  {
    id: "video",
    icon: "ri-video-chat-line",
    label: "视频通话",
    title: "与全球任何人高清视频",
    desc: "一键发起视频通话，1080P 超清画质，支持多人同时视频。无论对方在美国、日本还是欧洲，网络畅通即可连线，就像面对面一样真实。",
    steps: [
      { icon: "ri-user-search-line", text: "搜索或选择联系人" },
      { icon: "ri-video-line", text: "点击视频通话按钮" },
      { icon: "ri-signal-wifi-line", text: "自动优化网络连接" },
      { icon: "ri-hd-line", text: "1080P 超清画面接通" },
    ],
    image: "https://readdy.ai/api/search-image?query=two%20smartphones%20showing%20video%20call%20app%20interface%20with%20clear%20faces%20on%20screen%2C%20modern%20clean%20UI%20design%2C%20one%20phone%20showing%20caller%20and%20one%20showing%20receiver%2C%20professional%20product%20mockup%20on%20light%20gray%20background%2C%20no%20text%20overlay&width=700&height=480&seq=demo_video_v2&orientation=landscape",
    color: "from-red-500 to-orange-500",
    badge: "核心功能",
  },
  {
    id: "message",
    icon: "ri-message-3-line",
    label: "即时消息",
    title: "文字语音图片全支持",
    desc: "支持文字、语音、图片、视频、文件等全类型消息，毫秒级实时传递。内置 AI 翻译，50+ 语言自动翻译，和外国朋友聊天零障碍。",
    steps: [
      { icon: "ri-keyboard-line", text: "输入文字或录制语音" },
      { icon: "ri-translate-2", text: "AI 自动识别语言" },
      { icon: "ri-send-plane-line", text: "一键发送全球传递" },
      { icon: "ri-check-double-line", text: "实时已读回执确认" },
    ],
    image: "https://readdy.ai/api/search-image?query=smartphone%20showing%20chat%20messaging%20app%20with%20conversation%20bubbles%20in%20multiple%20languages%2C%20translation%20feature%20UI%2C%20modern%20clean%20dark%20theme%20interface%2C%20professional%20product%20mockup%20on%20light%20background%2C%20no%20text%20overlay&width=700&height=480&seq=demo_msg_v2&orientation=landscape",
    color: "from-green-500 to-teal-500",
    badge: "全语言支持",
  },
  {
    id: "group",
    icon: "ri-group-3-line",
    label: "群组聊天",
    title: "5000 人超大群组",
    desc: "创建最多 5000 人的超大群组，支持群视频会议、群公告、群文件共享。无论是家族群、购物社区还是商务团队，都能轻松管理。",
    steps: [
      { icon: "ri-group-line", text: "创建或加入群组" },
      { icon: "ri-megaphone-line", text: "发布群公告消息" },
      { icon: "ri-file-transfer-line", text: "共享文件和图片" },
      { icon: "ri-video-chat-line", text: "发起多人视频会议" },
    ],
    image: "https://readdy.ai/api/search-image?query=smartphone%20showing%20group%20chat%20interface%20with%20multiple%20participant%20avatars%20and%20message%20bubbles%2C%20modern%20clean%20UI%20design%2C%20group%20video%20call%20feature%20visible%2C%20professional%20product%20mockup%20on%20light%20background%2C%20no%20text%20overlay&width=700&height=480&seq=demo_group_v2&orientation=landscape",
    color: "from-amber-500 to-orange-500",
    badge: "最多5000人",
  },
  {
    id: "gift",
    icon: "ri-gift-line",
    label: "礼物分享",
    title: "一键分享商城礼物",
    desc: "直接在 Crowntalk 内浏览皇冠鸿运商城商品，生成精美礼物卡片发送给好友。对方点击即可查看商品详情并购买，让节日祝福更有温度。",
    steps: [
      { icon: "ri-store-line", text: "浏览商城商品" },
      { icon: "ri-gift-2-line", text: "生成礼物卡片" },
      { icon: "ri-share-line", text: "发送给好友" },
      { icon: "ri-shopping-bag-line", text: "好友一键购买" },
    ],
    image: "https://readdy.ai/api/search-image?query=smartphone%20showing%20gift%20card%20sharing%20feature%20in%20chat%20app%20with%20product%20card%20and%20buy%20button%2C%20festive%20colorful%20UI%20design%2C%20professional%20product%20mockup%20on%20light%20background%2C%20no%20text%20overlay&width=700&height=480&seq=demo_gift_v2&orientation=landscape",
    color: "from-pink-500 to-red-500",
    badge: "独家功能",
  },
];

function DemoSection() {
  const [active, setActive] = useState(0);
  const scenario = demoScenarios[active];

  return (
    <div>
      {/* Tab switcher */}
      <div className="flex items-center justify-center gap-3 mb-10 flex-wrap">
        {demoScenarios.map((s, idx) => (
          <button
            key={s.id}
            onClick={() => setActive(idx)}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              active === idx
                ? "bg-red-500 text-white"
                : "bg-gray-100 text-gray-500 hover:bg-gray-200"
            }`}
          >
            <i className={`${s.icon}`}></i>
            {s.label}
          </button>
        ))}
      </div>

      {/* Demo content */}
      <div className="bg-gray-50 rounded-3xl overflow-hidden">
        <div className="flex flex-col lg:flex-row">
          {/* Left: info */}
          <div className="flex-1 p-10 flex flex-col justify-center">
            <div className="flex items-center gap-3 mb-5">
              <div className={`w-12 h-12 flex items-center justify-center bg-gradient-to-br ${scenario.color} rounded-xl`}>
                <i className={`${scenario.icon} text-white text-xl`}></i>
              </div>
              <span className="bg-red-100 text-red-500 text-xs px-3 py-1 rounded-full font-medium">
                {scenario.badge}
              </span>
            </div>
            <h3
              className="text-2xl font-bold text-gray-900 mb-4"
              style={{ fontFamily: "'Noto Serif SC', serif" }}
            >
              {scenario.title}
            </h3>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              {scenario.desc}
            </p>

            {/* Steps */}
            <div className="space-y-3">
              {scenario.steps.map((step, i) => (
                <div key={i} className="flex items-center gap-4">
                  <div className="flex items-center gap-3">
                    <div className={`w-7 h-7 flex items-center justify-center bg-gradient-to-br ${scenario.color} rounded-full text-white text-xs font-bold flex-shrink-0`}>
                      {i + 1}
                    </div>
                    <div className="w-8 h-8 flex items-center justify-center bg-white rounded-lg flex-shrink-0">
                      <i className={`${step.icon} text-gray-500 text-base`}></i>
                    </div>
                  </div>
                  <span className="text-gray-600 text-sm">{step.text}</span>
                </div>
              ))}
            </div>

            <a
              href="#download"
              className={`mt-8 inline-flex items-center gap-2 bg-gradient-to-r ${scenario.color} text-white px-7 py-3 rounded-xl font-bold text-sm transition-opacity hover:opacity-90 cursor-pointer whitespace-nowrap w-fit`}
            >
              <i className="ri-download-line"></i>
              立即下载体验
            </a>
          </div>

          {/* Right: image */}
          <div className="flex-1 relative min-h-[320px] lg:min-h-0">
            <img
              src={scenario.image}
              alt={scenario.label}
              className="w-full h-full object-cover object-top"
              style={{ minHeight: "360px" }}
            />
            {/* Floating UI elements */}
            <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-sm rounded-xl px-4 py-2.5 text-xs font-medium text-gray-700">
              <i className={`${scenario.icon} text-red-500 mr-1.5`}></i>
              {scenario.label}演示
            </div>
            <div className="absolute bottom-6 right-6 bg-black/70 text-white rounded-xl px-4 py-2.5 text-xs">
              <i className="ri-global-line mr-1 text-red-300"></i>
              全球 180+ 国家可用
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function CrownChatPage() {
  const [activeScreen, setActiveScreen] = useState(0);
  const [activeDownload, setActiveDownload] = useState("apk");
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState<"login" | "signup">("login");
  const [currentUser, setCurrentUser] = useState<{ name: string; avatar: string } | null>(null);

  const openAuth = (mode: "login" | "signup") => {
    setAuthMode(mode);
    setAuthOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Crowntalk 下载 | 全球视频通话·AI翻译·华为小米安卓可用 | 皇冠鸿运商城"
        description="Crowntalk — 像微信一样简单，连接全球任何人。1080P高清视频通话，50+语言AI实时翻译，覆盖180+国家，支持苹果App Store及华为小米OPPO等国内安卓手机直接安装APK，免费下载。"
        keywords="Crowntalk下载,全球视频通话,即时通讯,AI实时翻译,跨国通话,华为安卓APK,社交购物"
        canonical={`${SITE_URL}/crowntalk`}
        jsonLd={crownchatJsonLd}
      />
      {/* Top bar */}
      <div className="bg-red-600 text-white text-xs py-1.5 px-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <span>皇冠鸿运商城 — Crowntalk 全球社交通讯应用</span>
          <a href="/" className="hover:underline cursor-pointer flex items-center gap-1">
            <i className="ri-home-line"></i> 返回首页
          </a>
        </div>
      </div>

      {/* Nav */}
      <nav className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/f704ac6a-a45e-41ab-b34d-a4b4313691a9.png"
              alt="Logo"
              className="h-9 w-auto object-contain"
            />
            <span
              className="text-red-600 font-bold text-lg hidden sm:block whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif SC', serif" }}
            >
              皇冠鸿运商城
            </span>
          </a>
          <div className="flex items-center gap-4">
            <a href="/" className="text-gray-500 hover:text-red-500 text-sm cursor-pointer whitespace-nowrap hidden md:block">
              首页
            </a>
            <a href="/products" className="text-gray-500 hover:text-red-500 text-sm cursor-pointer whitespace-nowrap hidden md:block">
              商品列表
            </a>
            <span className="text-red-500 font-semibold text-sm whitespace-nowrap border-b-2 border-red-500 pb-0.5 hidden md:block">
              Crowntalk
            </span>
            <a
              href="#download"
              className="bg-red-500 hover:bg-red-600 text-white text-sm px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-download-line mr-1"></i>下载
            </a>
            {currentUser ? (
              <div className="flex items-center gap-2 cursor-pointer group relative">
                <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full text-gray-900 font-bold text-sm">
                  {currentUser.avatar}
                </div>
                <span className="text-gray-700 text-sm font-medium hidden sm:block whitespace-nowrap">{currentUser.name}</span>
                <button
                  onClick={() => setCurrentUser(null)}
                  className="hidden group-hover:flex items-center gap-1 text-xs text-gray-400 hover:text-red-500 cursor-pointer whitespace-nowrap ml-1"
                >
                  <i className="ri-logout-box-line"></i>退出
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <button
                  onClick={() => openAuth("login")}
                  className="text-gray-600 hover:text-gray-900 text-sm font-medium cursor-pointer whitespace-nowrap px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  登录
                </button>
                <button
                  onClick={() => openAuth("signup")}
                  className="bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-gray-900 text-sm font-bold px-4 py-2 rounded-lg transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-user-add-line mr-1"></i>注册
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative overflow-hidden min-h-[600px] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=global%20communication%20network%20with%20glowing%20light%20connections%20between%20continents%20on%20deep%20dark%20navy%20background%2C%20abstract%20technology%20art%2C%20warm%20golden%20and%20red%20accent%20colors%2C%20wide%20panoramic%20cinematic%20view%2C%20no%20text%2C%20no%20people&width=1440&height=700&seq=cc_hero_v2&orientation=landscape"
            alt="CrownChat Hero"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/30"></div>
        </div>

        <div className="relative w-full max-w-7xl mx-auto px-4 py-20 flex flex-col lg:flex-row items-center gap-16">
          {/* Left content */}
          <div className="flex-1 text-white">
            <div className="flex items-center gap-2 mb-5">
              <span className="bg-red-500/30 border border-red-400/40 text-red-200 text-xs px-3 py-1 rounded-full font-medium">
                <i className="ri-global-line mr-1"></i>全球通讯 · 像微信一样简单
              </span>
            </div>

            <div className="inline-flex items-center gap-4 mb-5 bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-500 rounded-2xl px-5 py-4">
              <img
                src="https://public.readdy.ai/ai/img_res/f704ac6a-a45e-41ab-b34d-a4b4313691a9.png"
                alt="CrownChat"
                className="w-16 h-16 object-contain flex-shrink-0"
              />
              <div>
                <h1
                  className="text-5xl md:text-6xl font-bold text-gray-900"
                  style={{ fontFamily: "'Noto Serif SC', serif" }}
                >
                  Crowntalk
                </h1>
                <p className="text-gray-800/70 text-sm mt-1">皇冠鸿运商城官方全球社交应用</p>
              </div>
            </div>

            <p className="text-white/90 text-xl leading-relaxed mb-3 max-w-lg">
              像微信一样简单，连接全球任何人
            </p>
            <p className="text-white/65 text-base leading-relaxed mb-8 max-w-lg">
              无论对方在哪个国家，都能即时通讯、高清视频通话。
              支持苹果 App Store 下载，国内华为、小米、OPPO 等所有安卓手机也可直接安装使用。
            </p>

            {/* Key highlights */}
            <div className="flex flex-wrap gap-3 mb-8">
              {[
                { icon: "ri-video-line", text: "全球视频通话" },
                { icon: "ri-apple-line", text: "App Store 可下载" },
                { icon: "ri-android-line", text: "国内安卓直接用" },
                { icon: "ri-earth-line", text: "180+ 国家可用" },
              ].map((item) => (
                <div
                  key={item.text}
                  className="flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-2 text-sm text-white/90"
                >
                  <i className={`${item.icon} text-red-300`}></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>

            {/* CTA buttons */}
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => openAuth("signup")}
                className="flex items-center justify-center gap-3 bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-gray-900 px-7 py-4 rounded-xl font-bold transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-user-add-line text-xl"></i>
                <div className="text-left">
                  <p className="text-xs text-gray-700">免费注册</p>
                  <p className="text-sm font-bold">立即开始使用</p>
                </div>
              </button>
              <button
                onClick={() => openAuth("login")}
                className="flex items-center justify-center gap-3 bg-white/15 hover:bg-white/25 border border-white/30 text-white px-7 py-4 rounded-xl font-bold transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-login-box-line text-xl"></i>
                <div className="text-left">
                  <p className="text-xs text-white/70">已有账号</p>
                  <p className="text-sm font-bold">登录</p>
                </div>
              </button>
              <a
                href="#download"
                className="flex items-center justify-center gap-3 bg-red-500 hover:bg-red-600 text-white px-7 py-4 rounded-xl font-bold transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-cloud-line text-xl"></i>
                <div className="text-left">
                  <p className="text-xs text-red-200">国内安卓</p>
                  <p className="text-sm font-bold">APK 下载</p>
                </div>
              </a>
            </div>
          </div>

          {/* Right: Phone screens */}
          <div className="flex-shrink-0 flex items-end gap-3">
            {phoneScreens.map((screen, idx) => (
              <div
                key={idx}
                onClick={() => setActiveScreen(idx)}
                className={`relative cursor-pointer transition-all duration-300 ${
                  idx === activeScreen
                    ? "scale-105 z-10"
                    : idx === 1
                    ? "scale-100"
                    : "scale-90 opacity-70"
                }`}
                style={{ width: idx === activeScreen ? "160px" : "130px" }}
              >
                <img
                  src={screen.img}
                  alt={screen.label}
                  className="w-full rounded-2xl object-cover object-top"
                  style={{ height: idx === activeScreen ? "300px" : "260px" }}
                />
                <div className="absolute bottom-2 left-0 right-0 text-center">
                  <span className="bg-black/60 text-white text-xs px-2 py-0.5 rounded-full">
                    {screen.label}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats bar */}
      <section className="bg-red-500 py-8">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center text-white flex flex-col items-center gap-1">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full mb-1">
                  <i className={`${stat.icon} text-white text-lg`}></i>
                </div>
                <p className="text-3xl font-bold" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                  {stat.value}
                </p>
                <p className="text-red-100 text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video call highlight */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-14">
            <div className="flex-1">
              <span className="inline-block bg-red-100 text-red-500 text-xs px-3 py-1 rounded-full mb-5 font-medium">
                <i className="ri-video-chat-line mr-1"></i> 核心功能
              </span>
              <h2
                className="text-4xl font-bold text-gray-900 mb-5 leading-tight"
                style={{ fontFamily: "'Noto Serif SC', serif" }}
              >
                与全球任何人<br />
                <span className="text-red-500">高清视频通话</span>
              </h2>
              <p className="text-gray-500 text-base leading-relaxed mb-8 max-w-lg">
                Crowntalk 支持与全球任何国家的人进行一对一或多人视频通话，1080P 超清画质，
                低延迟技术确保通话流畅，就像面对面交流一样真实。无论对方在美国、日本、欧洲还是东南亚，
                只要有网络，随时随地都能视频。
              </p>
              <div className="space-y-4 mb-8">
                {[
                  { icon: "ri-hd-line", title: "1080P 超清画质", desc: "高清视频，细节清晰，告别模糊通话" },
                  { icon: "ri-group-line", title: "多人视频会议", desc: "支持最多 50 人同时视频，家庭聚会、商务会议都适用" },
                  { icon: "ri-wifi-line", title: "弱网优化技术", desc: "网络不稳定时自动优化，保持通话流畅不断线" },
                  { icon: "ri-lock-line", title: "通话全程加密", desc: "端对端加密保护，通话内容完全私密" },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-red-50 rounded-xl flex-shrink-0">
                      <i className={`${item.icon} text-red-500 text-lg`}></i>
                    </div>
                    <div>
                      <p className="text-gray-800 font-semibold text-sm">{item.title}</p>
                      <p className="text-gray-400 text-xs mt-0.5">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex-1 relative">
              <img
                src="https://readdy.ai/api/search-image?query=two%20smartphones%20side%20by%20side%20showing%20video%20call%20between%20two%20people%2C%20modern%20app%20interface%2C%20clean%20professional%20mockup%2C%20warm%20light%20background%2C%20no%20text%20overlay%2C%20high%20quality%20render&width=600&height=500&seq=cc_videocall&orientation=landscape"
                alt="视频通话"
                className="w-full rounded-2xl object-cover object-top"
                style={{ height: "380px" }}
              />
              <div className="absolute top-4 right-4 bg-white rounded-xl px-4 py-2.5 text-sm font-medium text-gray-700">
                <i className="ri-signal-wifi-line text-green-500 mr-1"></i>
                <span className="text-green-600 font-bold">HD</span> 通话中
              </div>
              <div className="absolute bottom-4 left-4 bg-black/70 text-white rounded-xl px-4 py-2.5 text-xs">
                <i className="ri-earth-line mr-1 text-red-300"></i>
                跨越 180+ 国家，随时连线
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2
              className="text-3xl font-bold text-gray-900 mb-3"
              style={{ fontFamily: "'Noto Serif SC', serif" }}
            >
              为什么选择 Crowntalk？
            </h2>
            <p className="text-gray-400 text-base max-w-xl mx-auto">
              不只是聊天工具，更是连接全球购物社交的超级平台
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((feat) => (
              <div
                key={feat.title}
                className="bg-white rounded-2xl p-6 hover:scale-[1.02] transition-transform duration-200 cursor-default relative"
              >
                {feat.tag && (
                  <span className="absolute top-4 right-4 bg-red-100 text-red-500 text-xs px-2 py-0.5 rounded-full font-medium">
                    {feat.tag}
                  </span>
                )}
                <div className={`w-12 h-12 flex items-center justify-center ${feat.color} rounded-xl mb-4`}>
                  <i className={`${feat.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-gray-800 font-bold text-base mb-2">{feat.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Demo Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-14">
            <span className="inline-block bg-red-100 text-red-500 text-xs px-3 py-1 rounded-full mb-4 font-medium">
              <i className="ri-play-circle-line mr-1"></i> 功能演示
            </span>
            <h2
              className="text-3xl font-bold text-gray-900 mb-3"
              style={{ fontFamily: "'Noto Serif SC', serif" }}
            >
              看看 Crowntalk 怎么用
            </h2>
            <p className="text-gray-400 text-base max-w-xl mx-auto">
              真实使用场景演示，视频通话、消息发送、礼物分享，一目了然
            </p>
          </div>

          {/* Scenario tabs */}
          <DemoSection />
        </div>
      </section>

      {/* Compatible phones */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2
              className="text-3xl font-bold text-gray-900 mb-3"
              style={{ fontFamily: "'Noto Serif SC', serif" }}
            >
              国内所有手机均可使用
            </h2>
            <p className="text-gray-400 text-base max-w-xl mx-auto">
              无需 Google 服务，直接下载 APK 安装包，华为、小米、OPPO 等国内主流手机全部支持
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 mb-10">
            {compatiblePhones.map((phone) => (
              <div
                key={phone.brand}
                className="flex flex-col items-center gap-2 p-4 bg-gray-50 rounded-xl hover:bg-red-50 transition-colors cursor-default"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full">
                  <i className={`${phone.icon} text-gray-600 text-xl`}></i>
                </div>
                <p className="text-gray-800 font-bold text-sm">{phone.brand}</p>
                <p className="text-gray-400 text-xs text-center leading-tight">{phone.models}</p>
              </div>
            ))}
          </div>
          <div className="bg-red-50 border border-red-100 rounded-2xl p-6 flex flex-col sm:flex-row items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-red-500 rounded-xl flex-shrink-0">
              <i className="ri-information-line text-white text-xl"></i>
            </div>
            <div className="flex-1 text-center sm:text-left">
              <p className="text-gray-800 font-semibold text-sm mb-1">国内用户下载说明</p>
              <p className="text-gray-500 text-sm">
                由于国内应用商店限制，推荐直接下载 APK 安装包。下载后在手机设置中允许"未知来源"安装即可，
                安全可靠，与 App Store 版本功能完全一致。
              </p>
            </div>
            <a
              href="#download"
              className="bg-red-500 hover:bg-red-600 text-white px-6 py-2.5 rounded-xl font-medium text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-download-line mr-1"></i>下载 APK
            </a>
          </div>
        </div>
      </section>

      {/* Gift sharing */}
      <section className="py-16 bg-gradient-to-br from-red-600 to-red-800">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="flex-1 text-white">
              <span className="inline-block bg-white/20 text-white text-xs px-3 py-1 rounded-full mb-5 font-medium">
                <i className="ri-gift-line mr-1"></i> 独家功能
              </span>
              <h2
                className="text-3xl font-bold mb-5 leading-tight"
                style={{ fontFamily: "'Noto Serif SC', serif" }}
              >
                节日礼物分享，<br />让爱跨越距离
              </h2>
              <p className="text-white/80 text-base leading-relaxed mb-6">
                在 CrownChat 中直接浏览皇冠鸿运商城商品，一键将心仪礼物分享给全球好友。
                对方可以直接在 App 内查看商品详情并购买，让节日祝福更有温度。
              </p>
              <div className="space-y-3">
                {[
                  "浏览皇冠鸿运商城全品类商品",
                  "一键生成礼物卡片发送给好友",
                  "好友可直接在 App 内购买",
                  "支持全球配送，礼物直达心意",
                ].map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center bg-white/30 rounded-full flex-shrink-0">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-white/90 text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex-1 grid grid-cols-2 gap-4">
              <img
                src="https://readdy.ai/api/search-image?query=smartphone%20showing%20gift%20card%20sharing%20feature%20in%20mobile%20app%2C%20colorful%20gift%20wrapping%20interface%2C%20warm%20festive%20colors%2C%20clean%20modern%20UI%20design%2C%20professional%20mockup%2C%20no%20text%20overlay&width=400&height=500&seq=cc_gift_v2a&orientation=portrait"
                alt="礼物分享"
                className="w-full rounded-2xl object-cover object-top"
                style={{ height: "260px" }}
              />
              <img
                src="https://readdy.ai/api/search-image?query=smartphone%20showing%20online%20shopping%20product%20browsing%20in%20chat%20app%2C%20product%20cards%20with%20prices%2C%20clean%20modern%20UI%20design%2C%20professional%20mockup%2C%20no%20text%20overlay%2C%20warm%20background&width=400&height=500&seq=cc_gift_v2b&orientation=portrait"
                alt="商城购物"
                className="w-full rounded-2xl object-cover object-top mt-8"
                style={{ height: "260px" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Download section — Gold Theme */}
      <section id="download" className="py-20 relative overflow-hidden" style={{ background: "linear-gradient(135deg, #1a1200 0%, #2d1f00 40%, #1a1200 100%)" }}>
        {/* Gold shimmer overlay */}
        <div className="absolute inset-0 opacity-20" style={{ background: "radial-gradient(ellipse at 30% 50%, #f59e0b 0%, transparent 60%), radial-gradient(ellipse at 70% 30%, #d97706 0%, transparent 50%)" }}></div>
        {/* Decorative gold lines */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent opacity-60"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent opacity-60"></div>

        <div className="relative max-w-5xl mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-amber-400/20 border border-amber-400/40 text-amber-300 text-xs px-4 py-1.5 rounded-full mb-5 font-medium">
              <i className="ri-download-cloud-line"></i> 免费下载 · 全球可用
            </div>
            <h2
              className="text-4xl font-bold mb-3"
              style={{ fontFamily: "'Noto Serif SC', serif", background: "linear-gradient(135deg, #fbbf24, #f59e0b, #d97706)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}
            >
              立即下载 Crowntalk
            </h2>
            <p className="text-amber-200/60 text-base">
              Crowntalk 免费下载，注册即可使用 · 支持全球 180+ 国家 · 苹果 App Store · 国内安卓手机全支持
            </p>
          </div>

          {/* Download cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
            {downloadOptions.map((opt) => (
              <div
                key={opt.id}
                onClick={() => setActiveDownload(opt.id)}
                className={`rounded-2xl p-6 cursor-pointer transition-all border-2 ${
                  activeDownload === opt.id
                    ? "border-amber-400 bg-amber-400/10"
                    : "border-amber-400/20 bg-white/5 hover:border-amber-400/50 hover:bg-amber-400/5"
                }`}
              >
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${activeDownload === opt.id ? "bg-amber-400/20" : "bg-white/10"}`}>
                    <i className={`${opt.icon} text-2xl ${activeDownload === opt.id ? "text-amber-400" : "text-amber-300/70"}`}></i>
                  </div>
                  <span className={`text-xs px-2.5 py-1 rounded-full font-medium border ${
                    activeDownload === opt.id
                      ? "bg-amber-400/20 border-amber-400/50 text-amber-300"
                      : "bg-white/5 border-amber-400/20 text-amber-400/60"
                  }`}>
                    {opt.badge}
                  </span>
                </div>
                <h3 className="text-amber-100 font-bold text-lg mb-1">{opt.title}</h3>
                <p className="text-amber-300/60 text-sm mb-1">{opt.subtitle}</p>
                <p className="text-amber-400/40 text-xs mb-5">{opt.desc}</p>
                <button
                  className={`w-full py-3 rounded-xl font-bold text-sm transition-all cursor-pointer whitespace-nowrap ${
                    activeDownload === opt.id
                      ? "bg-gradient-to-r from-amber-400 to-yellow-500 text-gray-900 hover:from-amber-500 hover:to-yellow-600"
                      : "bg-amber-400/10 text-amber-300 border border-amber-400/30 hover:bg-amber-400/20"
                  }`}
                >
                  <i className="ri-download-line mr-2"></i>{opt.btnText}
                </button>
                <p className="text-amber-400/30 text-xs mt-3 text-center">
                  版本 3.2.1 · 大小 {opt.size} · 免费
                </p>
              </div>
            ))}
          </div>

          {/* QR code area */}
          <div className="rounded-2xl p-8 flex flex-col sm:flex-row items-center gap-8 border border-amber-400/20 bg-amber-400/5">
            <div className="flex-shrink-0 w-28 h-28 bg-white rounded-xl flex items-center justify-center p-2">
              <div className="grid grid-cols-5 gap-0.5">
                {Array.from({ length: 25 }).map((_, i) => (
                  <div
                    key={i}
                    className={`w-3.5 h-3.5 flex items-center justify-center rounded-sm ${
                      [0,1,2,3,4,5,9,10,14,15,19,20,21,22,23,24,6,12,18,7,11,17,8,13,16].includes(i)
                        ? "bg-amber-800"
                        : "bg-white"
                    }`}
                  ></div>
                ))}
              </div>
            </div>
            <div className="flex-1 text-center sm:text-left">
              <h3 className="text-amber-100 font-bold text-lg mb-2">
                <i className="ri-qr-code-line text-amber-400 mr-2"></i>扫码下载 Crowntalk
              </h3>
              <p className="text-amber-300/60 text-sm mb-3">
                用手机扫描二维码，自动识别设备类型，iOS 跳转 App Store，安卓直接下载 APK 安装包
              </p>
              <div className="flex flex-wrap gap-2">
                {["华为", "小米", "OPPO", "vivo", "iPhone", "三星"].map((brand) => (
                  <span key={brand} className="bg-amber-400/10 border border-amber-400/20 text-amber-300 text-xs px-3 py-1 rounded-full">
                    {brand}
                  </span>
                ))}
                <span className="bg-amber-400/10 border border-amber-400/20 text-amber-300 text-xs px-3 py-1 rounded-full">更多...</span>
              </div>
            </div>
            <div className="flex-shrink-0 text-center">
              <p className="text-amber-400/50 text-xs mb-3">系统要求</p>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-amber-300/70 text-xs bg-amber-400/10 px-3 py-1.5 rounded-lg">
                  <i className="ri-apple-line text-amber-400"></i>
                  <span>iOS 14.0+</span>
                </div>
                <div className="flex items-center gap-2 text-amber-300/70 text-xs bg-amber-400/10 px-3 py-1.5 rounded-lg">
                  <i className="ri-android-line text-amber-400"></i>
                  <span>Android 8.0+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2
              className="text-3xl font-bold text-gray-900 mb-2"
              style={{ fontFamily: "'Noto Serif SC', serif" }}
            >
              全球用户真实好评
            </h2>
            <p className="text-gray-400 text-sm">来自全球 180+ 国家用户的真实使用体验</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {reviews.map((r) => (
              <div key={r.name} className="bg-gray-50 rounded-2xl p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div
                    className={`w-11 h-11 flex items-center justify-center ${r.avatarBg} rounded-full text-white font-bold flex-shrink-0`}
                  >
                    {r.avatar}
                  </div>
                  <div>
                    <p className="text-gray-800 font-semibold text-sm">{r.name}</p>
                    <p className="text-gray-400 text-xs">{r.country}</p>
                  </div>
                  <div className="ml-auto flex items-center gap-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                    ))}
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{r.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="py-14 bg-red-500">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2
            className="text-3xl font-bold text-white mb-3"
            style={{ fontFamily: "'Noto Serif SC', serif" }}
          >
            加入 Crowntalk 2 亿全球用户
          </h2>
          <p className="text-red-100 text-base mb-8">
            免费注册 · 无广告 · 端对端加密 · 苹果 App Store 可下载 · 国内安卓手机全支持
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => openAuth("signup")}
              className="bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-gray-900 px-8 py-3.5 rounded-xl font-bold transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-user-add-line mr-2"></i>免费注册账号
            </button>
            <button
              onClick={() => openAuth("login")}
              className="bg-white text-red-500 px-8 py-3.5 rounded-xl font-bold transition-all cursor-pointer whitespace-nowrap hover:bg-red-50"
            >
              <i className="ri-login-box-line mr-2"></i>已有账号登录
            </button>
            <a
              href="#download"
              className="bg-gray-900 text-white px-8 py-3.5 rounded-xl font-bold transition-colors cursor-pointer whitespace-nowrap hover:bg-gray-800"
            >
              <i className="ri-download-cloud-line mr-2"></i>APK 下载
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-6 text-center text-xs">
        <p>© 2026 皇冠鸿运商城 Crown HongYun Mall · Crowntalk. 保留所有权利。</p>
        <div className="flex items-center justify-center gap-4 mt-2">
          <a href="/" className="hover:text-white cursor-pointer">首页</a>
          <a href="/products" className="hover:text-white cursor-pointer">商品列表</a>
          <a href="/privacy" className="hover:text-white cursor-pointer">隐私政策</a>
          <a href="/terms" className="hover:text-white cursor-pointer">用户协议</a>
        </div>
      </footer>

      {/* Auth Modal */}
      <AuthModal
        isOpen={authOpen}
        onClose={() => setAuthOpen(false)}
        onSuccess={(user) => setCurrentUser(user)}
      />
    </div>
  );
}
